<template>
  <div class="homepage">
    <div class="lottie"></div>
    <!--    showPrivacy-->
    <privacy
      v-if="false"
      @agree="closePwindow"
      @noAgree="noAgree"
      @showPolicy="showPolicy"
      @showChildPolicy="showChildPolicy"
    />
    <div class="homepage_cont">
      <!--      <img ondragstart="return false;" src="../../../assets/img/home/logo.png" alt class="logo" />-->
      <div class="content_right">
        <div class="img_box">
          <img
            ondragstart="return false;"
            src="../../../assets/img/home/material.png"
            alt
            class="material"
          />
          <!--          <img ondragstart="return false;" src="../../../assets/img/home/line.png" alt class="line" />-->
          <a
            class="login"
            href="javascript:;;"
            @click="goLogin"
            v-if="loginBtnShow"
            >登录</a
          >
          <p class="cursor" :class="{ checked: isChecked }" @click="agree">
            我已阅读并同意 <i @click.stop="showPolicy">《隐私政策》、</i
            ><i @click.stop="showChildPolicy">《儿童隐私保护政策》</i>
          </p>
        </div>
      </div>
      <div class="m-contact">
        <a href="mailto:huojianban@zhuhuotech.com"
          >联系邮箱：huojianban@zhuhuotech.com</a
        >
      </div>
      <p class="version" v-if="LIMI_ENV">版本号v {{ version }}</p>
    </div>
    <policy from="home" v-if="$route.query.type == 1"></policy>
    <childrenPolicy from="home" v-if="$route.query.type == 2"></childrenPolicy>
    <icp />
    <toast
      :showText="showText"
      :waitTime="3000"
      v-if="showText"
      @toastCallBack="showText = ''"
    ></toast>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import privacy from '@/components/basic/privacy/privacy';
import utils from 'utils';
import common from 'common';
import liSrv from 'liSrv';
import icp from '@/components/basic/icp.vue';
import toast from '@/components/basic/toast.vue';
import lottie from 'lottie-web-limi';
import policy from '@/components/bussiness/explain/explain.vue';
import childrenPolicy from '@/components/bussiness/explain/childrenPolicy.vue';
if (LIMI_ENV === 'electron') {
  var fs = window.require('fs');
  var ipc = window.require('electron').ipcRenderer;
}
export default {
  name: 'homepage',
  data() {
    return {
      version: common.version,
      LIMI_ENV: LIMI_ENV === 'electron',
      LOCAL_COOK: '',
      showPrivacy: false,
      alentanim: null,
      isChecked: false,
      showText: '',
    };
  },
  components: {
    privacy,
    icp,
    toast,
    policy,
    childrenPolicy,
  },
  computed: {
    ...mapState(['COOK', 'govideo', 'lesson_id']),
    loginBtnShow() {
      if (this.LIMI_ENV) {
        return !this.LOCAL_COOK;
      } else {
        return !(this.$route.query.lesson_id && this.$route.query.uid);
      }
    },
  },
  created() {
    let lesson_id = this.$route.query.lesson_id;
    let uid = this.$route.query.uid;
    let class_id = this.$route.query.class_id;
    if (lesson_id && uid && class_id) {
      if (this.govideo && this.lesson_id == lesson_id) {
        this.$router.push('/video');
      } else {
        this.getInfo();
      }
      return;
    }
    if (this.COOK) {
      this.$router.push('/class');
      return;
    }
    this.showPrivacy = this.getReadPrivacy();
    this.isChecked = this.LIMI_ENV
      ? utils.getNodeStorge('privacyIsChecked')
      : common.get('privacyIsChecked');
    if (this.LIMI_ENV) {
      !this.showPrivacy && this.isChecked && this.autoLogin();
      this.downloadAgreement();
      let shellLog = common.get('shellLog') || [];
      shellLog.forEach((i) => {
        this.$root.eventHub.$emit('createLog', { id: i });
      });
    }
  },
  mounted() {
    this.$root.eventHub.$emit('createLog', { id: 'LMTrackEventLaunchInfo' });
    this.setLottieSize();
    window.onresize = this.setLottieSize;
    this.startAim();
  },
  methods: {
    ...mapMutations([
      'saveLogin',
      'saveIndexConfig',
      'saveGoVideo',
      'saveGoVideoInfo',
      'updataVideoUrlState',
      'saveVideoUrl',
      'saveClassType',
      'saveLessonInfo',
    ]),
    ...mapActions(['getLoginInfo', 'getLessonList']),

    agree() {
      this.isChecked = !this.isChecked;
      this.LIMI_ENV
        ? utils.setNodeStorge('privacyIsChecked', this.isChecked)
        : common.set('privacyIsChecked', this.isChecked);
    },
    //展示儿童隐私政策
    showChildPolicy() {
      this.$router.replace({
        path: '/',
        query: {
          type: 2,
        },
      });
    },
    //展示隐私政策
    showPolicy() {
      this.$router.replace({
        path: '/',
        query: {
          type: 1,
        },
      });
    },
    goLogin() {
      if (!this.isChecked) {
        this.showText = '请勾选同意下方协议';
        return;
      }
      this.$router.push('/login');
    },
    // 背景动画
    startAim() {
      this.alentanim = lottie.loadAnimation({
        container: document.querySelector('.lottie'), // the dom element that will contain the animation
        renderer: 'svg', //svg,canvas
        loop: true,
        autoplay: true,
        path: '/static/lottie/entry/entry.json',
      });
    },
    setLottieSize() {
      let clientWidth = document.body.clientWidth;
      let clientHeight = document.body.clientHeight;
      let lottieDom = document.querySelector('.lottie');
      if (!lottieDom) return;
      if (clientHeight >= 750 && clientWidth >= 1334) {
        if (clientWidth / clientHeight > 1334 / 750) {
          lottieDom.style.width = '100%';
          lottieDom.style.height = (750 / 1334) * clientWidth + 'px';
        } else {
          lottieDom.style.height = '100%';
          lottieDom.style.width = (1334 / 750) * clientHeight + 'px';
        }
      } else if (clientHeight > 750 && clientWidth < 1334) {
        lottieDom.style.height = '100%';
        lottieDom.style.width = (1334 / 750) * clientHeight + 'px';
      } else if (clientHeight < 750 && clientWidth < 1334) {
        lottieDom.style.height = '750px';
        lottieDom.style.width = '1334px';
      } else if (clientHeight < 750 && clientWidth > 1334) {
        lottieDom.style.width = '100%';
        lottieDom.style.height = (750 / 1334) * clientWidth + 'px';
      }
    },
    downloadAgreement() {
      const pathArr = [
        'index.html',
        'forrecord/index.html',
        'forrecord/img/record.jpg',
        'children/index.html',
      ];
      pathArr.forEach((url) => {
        ipc.send('loadKeJian', {
          isForce: true,
          url: `https://agreement.limiketang.com/${url}`,
        });
      });
    },
    formatData(res) {
      common.setSession('lesson_list_data', res);
      this.saveBaseLessonInfo(res);
      this.alertData = {};
      res.lessonList.forEach((v, i) => {
        let type = 0; //0未上课 1等待上课 2正在上课 3上完课
        const isNextLesson = v.lessonListChild.some((i) => {
          if (
            i.lessonType == 7 &&
            this.compareTimeSize(i.beginTime) &&
            v.practiceStatus == 0
          ) {
            v.practiceStatus = 10;
          }
          return i.isNextLesson == 1;
        });
        if (v.lessonType == 7 && v.practiceStatus == 0) {
          v.practiceStatus = 10;
        }
        if (v.isNextLesson == 0 && (isNextLesson || this.class_type === 10)) {
          v.isNextLesson = 1;
        }
        if (v.isNextLesson == 1) {
          if (v.state == 2) {
            if (v.lessonListChild.length) {
              let index = v.lessonListChild.findIndex((item) => {
                return item.state == 2;
              });
              v.videoUrl = v.lessonListChild[index].videoUrl;
            }
            type = 2;
            if (this.$route.query['from'] !== 'video') {
              if (this.subject == 3) {
                this.alertData = {
                  show: true,
                  btn: '进入',
                  cancal: '取消',
                  lessonName: v.title,
                  imgNum: v.sort,
                  data: v,
                };
              } else {
                this.alertData = {
                  show: true,
                  btn: '进入',
                  cancal: '取消',
                  lessonName: v.title,
                  imgNum: i + 1,
                  data: v,
                };
              }
              this.$root.eventHub.$emit('createLog', {
                id: 'LMTrackEventLivingNotice',
              });
            }
          } else {
            if (!!v.beginTime) {
              let metime = v.beginTime.split(' ')[0];
              if (metime) {
                let arr = metime.split('-');
                if (v.lessonType == 1 || v.lessonType == 5) {
                  metime = `${arr[1]}月${arr[2]}日 ${v.beginTimeSlot || ''}`;
                } else {
                  metime = `${arr[1]}月${arr[2]}日`;
                }
              } else {
                metime = '等待开课';
              }
              v.me_begin_time_man = metime;
            }
            type = v.state == 3 ? 3 : 1;
            let flag = v.lessonListChild.some((i) => {
              if (i.lessonType == 7 && this.compareTimeSize(i.beginTime)) {
                i.state = 3;
              }
              return i.state == 3;
            });
            if (type < 2 && flag) {
              type = 3;
            }
          }
          if (LIMI_ENV === 'electron' && this.$route.query.from !== 'video') {
            this.getZip({ course_id: v.courseId });
          }
        } else {
          type = v.state == 1 ? 0 : v.state;
          let flag = v.lessonListChild.some((i) => {
            if (i.lessonType == 7 && this.compareTimeSize(i.beginTime)) {
              i.state = 3;
            }
            return i.state == 3;
          });
          if (type < 2 && flag) {
            type = 3;
          }
          let metime = v.beginTime.split(' ')[0];
          if (metime) {
            let arr = metime.split('-');
            if (v.lessonType == 1 || v.lessonType == 5) {
              metime = `${arr[1]}月${arr[2]}日 ${v.beginTimeSlot || ''}`;
            } else {
              metime = `${arr[1]}月${arr[2]}日`;
            }
            v.me_begin_time_man = metime;
          }
        }
        if (v.lessonType == 7 && this.compareTimeSize(v.beginTime)) {
          if (v.practiceStatus == 12) {
            type = 3;
          } else {
            type = 2;
          }
        }
        v.web_custom_type = type;
        if (
          LIMI_ENV === 'electron' &&
          this.isExperientialCourse &&
          this.$route.query.from !== 'video'
        ) {
          this.getZip({ course_id: v.courseId });
        }
      });
      //保存长连接地址
      if (res.wssUrl) {
        common.setSession('websocket_wss_url', res.wssUrl);
      } else {
        common.setSession('websocket_wss_url', '');
      }
      if (
        res.artemisGoldMedalInfo &&
        res.artemisGoldMedalInfo.isShowEntrance == 1
      ) {
        this.$parent.dailyTasksShow = true;
      }
      this.list = res.lessonList;
      let index = this.list.findIndex((item) => {
        return item.lessonId == this.composeLessInfo.lessonId;
      });
      if (index != -1 && this.showCompose) {
        this.$nextTick(() => {
          this.saveComposeLessInfo(
            Object.assign(this.list[index], { showCompose: false }),
          );
          this.$nextTick(() => {
            this.saveComposeLessInfo(
              Object.assign(this.list[index], { showCompose: true }),
            );
          });
        });
      }
      setTimeout(() => {
        this.scrollTop();
        this.$nextTick(this.playAmn);
      }, 0);
    },
    getInfo() {
      liSrv.getAPIList((re) => {
        this.saveIndexConfig(re);
        liSrv.getTeacherLessonInfo(
          {
            lessonId: this.$route.query.lesson_id,
            classId: this.$route.query.class_id,
            uid: this.$route.query.uid,
            teacherId: this.$route.query.teacher_id,
          },
          (res, ok) => {
            if (!ok) return;
            this.saveGoVideo(true);
            this.saveGoVideoInfo(res);
            //iframe 学管调用存储class_type
            this.saveClassType(parseInt(this.$route.query.class_type));
            common.setSession('websocket_wss_url', res.wss);
            common.set('phone', res.phoneNum);
            this.updataVideoUrlState({
              lesson_id: '',
              live_video_url_stream: '',
              live_video_url_type: '',
              live_video_url: '',
            });
            this.saveVideoUrl([]);
            if (this.$route.query.class_type == '10') {

              this.getLessonList({
                classId: this.$route.query.class_id,
                client: common.client,
                version: common.version,
              })
                .then(
                  ({ res, ok }) => {
                    if (!ok) {
                      return;
                    }
                    if (Array.isArray(res.lessonList)) {
                      const target = res.lessonList.find(
                        (item) =>
                          item['lessonId'] == this.$route.query.lesson_id,
                      );
                      this.saveLessonInfo(target);
                      this.$router.push('/video');
                    }
                  },
                  () => {},
                )
                .catch(() => {});
            } else {
              this.$router.push('/video');
            }
          },
        );
      });
    },
    noAgree() {
      this.showText = '您在同意隐私政策的情况下，方可继续使用本产品';
    },
    closePwindow() {
      if (this.LIMI_ENV) {
        utils.setNodeStorge('readPrivacy', true);
        utils.setNodeStorge('privacyIsChecked', true);
      } else {
        common.set('readPrivacy', true);
        common.set('privacyIsChecked', true);
      }
      this.$root.eventHub.$emit('checkMicrophonePermission');
      this.showPrivacy = false;
      this.isChecked = true;
    },
    getReadPrivacy() {
      if (this.LIMI_ENV) {
        if (!utils.getNodeStorge('readPrivacy')) {
          return true;
        }
      } else {
        if (!common.get('readPrivacy')) {
          return true;
        }
      }
      return false;
    },
    autoLogin() {
      const cook = utils.getNodeStorge('LOCAL_COOK');
      const paw = common.get('LOCAL_password');
      const phone = common.get('phone');
      this.LOCAL_COOK = cook && paw && phone ? cook : '';
      if (this.LOCAL_COOK) {
        let time = Date.now();
        liSrv.getAPIList(
          (re) => {
            this.saveIndexConfig(re);
            re.assetZip.forEach((url) => {
              ipc.send('loadKeJian', {
                url: url,
              });
            });
            re.kejianSound.sound.forEach((url) => {
              ipc.send('loadKeJian', {
                url: url,
              });
            });
            this.getLoginInfo({
              username: phone,
              password: paw,
              usertype: 'student',
              from: 'live_pc_h5',
            })
              .then(({ res, ok }) => {
                let newtime = Date.now() - time;
                if (ok) {
                  this.saveLogin({ phone: common.get('phone') });
                  newtime = newtime < 2000 ? 2000 - newtime : 0;
                  setTimeout(() => {
                    this.$router.replace({
                      name: 'class',
                      params: {
                        from: 'first',
                      },
                    });
                  }, newtime);
                } else {
                  this.removeLocal();
                }
              })
              .catch((err) => {
                this.removeLocal();
                this.$root.eventHub.$emit('createLog', {
                  id: 'LMTrackEventLoginSuccess',
                  data: {
                    result: 500,
                    content: err,
                  },
                });
              });
          },
          () => {
            this.LOCAL_COOK = '';
          },
        );
        return;
      }
    },
    removeLocal() {
      common.remove('LOCAL_COOK');
      fs && utils.removeStorge('LOCAL_COOK');
      common.remove('userId');
      common.remove('LOCAL_password');
      this.$router.replace({
        path: '/login',
      });
    },
  },
  beforeDestroy() {
    window.onresize = null;
    this.alentanim && this.alentanim.destroy();
    this.alentanim = null;
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.homepage {
  height: 100%;
  width: 100%;
  background: url(../../../assets/img/home/bg.png) no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
  .lottie {
    width: 100%;
    height: 720px;
    position: absolute;
    z-index: 0;
  }
  .homepage_cont {
    width: 1258px;
    margin: 0 auto;
    position: relative;
    height: 100%;
  }
  .logo {
    width: 111px;
    height: 30px;
    position: absolute;
    right: 0;
    margin: 88px 120px 0 0;
  }
  .content_right {
    height: 630px;
    width: 412px;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -315px;
    text-align: right;
    margin-right: 120px;
    .img_box {
      position: absolute;
      top: 50%;
      right: 0;
      .material {
        width: 328px;
        height: 227px;
        margin-top: -230px;
      }
      .line {
        width: 357px;
        height: 18px;
        margin-top: 5px;
      }
      p {
        clear: both;
        float: right;
        width: 460px;
        font-size: 18px;
        color: #fff;
        background: url('../../../assets/img/home/check.png') no-repeat left
          center;
        background-size: 18px;
        margin-top: 40px;
      }
      p.checked {
        background: url('../../../assets/img/home/checked.png') no-repeat left
          center;
        background-size: 18px;
      }
      i {
        color: #2298d4;
      }
    }
    .login {
      float: right;
      width: 300px;
      height: 60px;
      text-align: center;
      background: #fff;
      border-radius: 44px;
      line-height: 60px;
      font-size: 33px;
      color: #173576;
      margin-top: 200px;
      position: relative;
      > img {
        position: absolute;
        bottom: -30px;
        right: 0;
        width: 200px;
      }
    }

    .login:hover {
      background-color: #80bccd;
      color: #007a9c;
    }
  }
  .version {
    position: fixed;
    left: 30px;
    bottom: 60px;
    font-size: 18px;
    text-align: left;
    color: rgba(255, 255, 255, 0.8);
  }
  @media screen and (max-width: 1470px) {
    .content_right {
      .login {
        margin-top: 50px;
        > img {
          position: absolute;
          bottom: -30px;
          right: 0;
          width: 120px;
        }
      }
    }
  }
  @media screen and (min-width: 1600px) {
    .homepage_cont {
      width: 1258px * 1.3;
    }
    .logo {
      width: 111px * 1.3;
      height: 30px * 1.3;
      margin-right: 120px * 1.3;
    }
    .content_right {
      margin-right: 120px * 1.3;
      .img_box {
        .material {
          width: 328px * 1.3;
          height: 227px * 1.3;
          margin-top: -230px * 1.3;
        }
        .line {
          width: 357px * 1.3;
          height: 18px * 1.3;
          margin-top: 5px * 1.3;
        }
      }
      .login {
        width: 300px * 1.3;
        height: 60px * 1.3;
        border-radius: 60px * 1.3;
        line-height: 60px * 1.3;
        font-size: 33px * 1.3;
        margin-top: 200px * 1.3;
        position: relative;
      }
    }
  }
  @media screen and (min-width: 1920px) {
    .homepage_cont {
      width: 1258px * 1.5;
    }
    .logo {
      width: 111px * 1.5;
      height: 30px * 1.5;
      margin-right: 120px * 1.5;
    }
    .content_right {
      margin-right: 120px * 1.5;
      .img_box {
        .material {
          width: 328px * 1.5;
          height: 227px * 1.5;
          margin-top: -230px * 1.5;
        }
        .line {
          width: 357px * 1.5;
          height: 18px * 1.5;
          margin-top: 5px * 1.5;
        }
      }
      .login {
        width: 300px * 1.5;
        height: 60px * 1.5;
        border-radius: 60px * 1.5;
        line-height: 60px * 1.5;
        font-size: 33px * 1.5;
        margin-top: 200px * 1.5;
        position: relative;
      }
    }
  }
}
.m-contact {
  color: black;
  position: fixed;
  bottom: 20px;
  left: 40px;
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/homepage/homepage.vue